import React from 'react';
import useColors from 'ui/hooks/useColors';
import BackgroundAngle from './BackgroundAngle';
import BackgroundSwoop from './BackgroundSwoop';
import { BackgroundType } from './types';

const HeaderBackground = ({ type, parentDimensions }) => {
  const { colorPrimary } = useColors();
  const secondaryFill = '#d4d4d6';
  switch (type) {
    case 'angle':
      return (
        <BackgroundAngle
          primaryFill={colorPrimary}
          secondaryFill={secondaryFill}
          parentDimensions={parentDimensions}
        />
      );
    case 'swoop':
      return (
        <BackgroundSwoop
          primaryFill={colorPrimary}
          secondaryFill={secondaryFill}
          parentDimensions={parentDimensions}
        />
      );
    default:
      return null;
  }
};

HeaderBackground.propTypes = { ...BackgroundType };

export default HeaderBackground;
